import { Grid, CardContent } from "@mui/material";
import { IGroundEvent } from "@vmosolutions/oc-interfaces";
import { FormHeader } from "../helpers";
import { DisplayEventComments } from "src/pages/CommentEditor/DisplayEventComments";

interface IGECommentsTabProps {
  groundEvent: IGroundEvent; // Id of the flight to retrieve and edit if provided.
  setLoadedGroundEvent: (eventValues: IGroundEvent) => void;
  updateTabState: (dirtyStatus: boolean) => void; // update parent with dirty status.
  mosaicId: string;
  setAPICallStatus: (statusMessage: string) => void;
}

/**
 * GroundEvent Comments Tab
 * @param props -
 */
export const GECommentsTab = (props: IGECommentsTabProps): JSX.Element => {
  const { groundEvent, setLoadedGroundEvent, updateTabState, mosaicId, setAPICallStatus } = props;
  const { _id, comments } = groundEvent ?? {};
  const subtitle = `(${comments?.length ?? 0})`;

  return (
    <CardContent id={`${mosaicId}-comments-editor`} className="form_card comments">
      <Grid container direction="column">
        <FormHeader title="Comments" subtitle={subtitle} />
        {groundEvent ? (
          <DisplayEventComments
            windowId={mosaicId}
            isFlight={false}
            eventId={_id}
            comments={comments}
            setLoadedGroundEvent={setLoadedGroundEvent}
            updateTabState={updateTabState}
          />
        ) : null}
      </Grid>
    </CardContent>
  );
};
